import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from "@angular/router";
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {BrowserModule} from "@angular/platform-browser";
import {CarouselModule, ModalModule, PopoverModule, TabsModule, TooltipModule} from "ngx-bootstrap";
import {AgmCoreModule} from '@agm/core';
import {LightboxModule} from "ngx-lightbox";
import {GooglePlaceModule} from "ngx-google-places-autocomplete";
import {ChartsModule} from "ng2-charts";
import {NgxPaginationModule} from "ngx-pagination";
import {BaseModule} from "../../../base/base.module";
import {SharedModule} from "../../../shared/shared/shared.module";
import {HousingInfoService} from "../../../services/housing-info/housing-info.service";
import {GoogleLocationMapper} from "../../../services/googlemapper/google-location-mapper.service";
import {AddComponent} from "./add/add.component";
import {ModalImportOsmComponent} from "./modal-import-osm/modal-import-osm.component";
import {BoundaryContainerComponent} from "./boundary-container/boundary-container.component";
import {OpenStreetMapsService} from "../../../services/open-street-maps/open-street-maps.service";

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    CarouselModule.forRoot(),
    TabsModule.forRoot(),
    PopoverModule.forRoot(),
    AgmCoreModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    NgxPaginationModule,
    BaseModule,
    SharedModule,
    GooglePlaceModule,
    LightboxModule,
    ChartsModule,
  ],
  declarations: [
    AddComponent,
    BoundaryContainerComponent,
    ModalImportOsmComponent
  ],
  providers: [
    HousingInfoService,
    OpenStreetMapsService,
    GoogleLocationMapper
  ],
  exports: []
})
export class BoundariesV2Module {
}
